import type { Theme } from '@mui/material';
import type { PNTheme } from './PNThemeProvider';
import { BOEDark } from './themes/BOEDark';
import { BOELight } from './themes/BOELight';
import { Hacker } from './themes/Hacker';
import { Holiday } from './themes/Holiday';
import { StackDark } from './themes/StackDark';
import { StackLight } from './themes/StackLight';

export const themes: Record<PNTheme, Theme> = {
  'Stack Light': StackLight,
  'Stack Dark': StackDark,

  'BOE Light Legacy': BOELight,
  'BOE Dark Legacy': BOEDark,

  Hacker: Hacker,
  Holiday: Holiday,
};
